import ENV from "config/Env";
import { typedQueryClient, usePermanentRealTimeUser, useTypedMutation } from "hooks";
import { WEBHOOK_TRIGGERS } from "models";
import { WebhooksQueryKeys } from "modules/WebhooksDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { toISOString } from "utils/dateHelperFunctions";

import type { Webhook } from "models";

type CreateWebhookResponse = {
  webhook_id: number;
};

export type CreateWebhookPayload = Pick<
  Webhook,
  "id" | "url" | "name" | "active" | "queued" | "dealer_id" | "checklist_id" | "dealer_location_id" | "block_creating_support_ticket" | "headers"
> & {
  user_id: number;
  webhook_trigger_id: WEBHOOK_TRIGGERS | null;
};

export const useCreateWebhookMutation = () => {
  const { user } = usePermanentRealTimeUser();

  return useTypedMutation<CreateWebhookPayload, CreateWebhookResponse>({
    mutationFn: async payload => (await ApiInstance.post(`/webhooks/create`, payload, ENV.dealerBaseURL)).data,
    onSuccess: (payload, response) => {
      const today = toISOString(new Date());
      const previousWebhooks = typedQueryClient.getQueryData(WebhooksQueryKeys.webhooks);

      typedQueryClient.setQueryData(WebhooksQueryKeys.webhooks, [
        ...(previousWebhooks || []),
        {
          ...payload,
          id: response.webhook_id,
          user: user,
          public_account_id: null,
          created_on: today,
          updated_on: today,
          block_creating_support_ticket: payload.block_creating_support_ticket,
          webhook_trigger_id: payload.webhook_trigger_id || WEBHOOK_TRIGGERS.CarInShop,
          headers: payload.headers?.map(({ name, value }) => ({ created_on: today, updated_on: today, id: -1, name, webhook_id: -1, value })) || []
        }
      ]);
    }
  });
};
